import { useState } from 'react';
import { Box, makeStyles, MenuItem, Select } from '@material-ui/core';
import { setSelectedGame, getGames } from 'redux/actions/games';
import { useDispatch, useSelector } from 'react-redux';
import { getEnglishDateWithTime, isEmpty } from 'utils/helpers';
import { useAsyncAction } from 'hooks';
import { MOBILE_BREAKPOINT } from 'utils/constants/theme';
import { TeamLogo } from 'components/elements';

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 387,
    height: 48,
    backgroundColor: '#fff',
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiSelect-selectMenu': {
      fontFamily: theme.custom.fonts.SFUITextRegular,
      fontSize: 14,
      color: theme.custom.palette.textGrey,
    },
    '& .MuiSelect-select:focus': {
      backgroundColor: 'unset',
    },
    [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
      width: '100%',
    },
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    fontFamily: theme.custom.fonts.SFProTextMedium,
    fontSize: 14,
    fontWeight: 500,
    color: '#000',
  },
  text: {
    color: theme.custom.palette.primary,
  },
  hidden: {
    backgroundColor: "transparent",
  }
}));

const GameSelector = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { results: games = [], selectedGame } = useSelector(
    (state) => state.games
  );
  const handleGameSelect = (e) => {
    dispatch(setSelectedGame(games.find((g) => g.id === e.target.value)));
  };

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useAsyncAction(getGames(), isEmpty(games));

  return (
    <Select
      variant="outlined"
      displayEmpty
      className={[classes.root, isMenuOpen && classes.hidden]}
      value={selectedGame?.id || ''}
      onChange={handleGameSelect}
      onOpen={() => setIsMenuOpen(true)}
      onClose={() => setIsMenuOpen(false)}
    >
      <MenuItem value="" disabled>
        Select Gameday
      </MenuItem>
      {games.map((item) => (
        <MenuItem key={item.id} value={item.id}>
          <Box className={classes.menuItem}>
            <TeamLogo team={item.visitorTeam} />
            <Box>{item.visitorTeam.name}</Box>
            <Box px={1} className={classes.text}>
              @
            </Box>
            <TeamLogo team={item.homeTeam} />
            <Box>{item.homeTeam.name}</Box>
            <Box color="textSecondary">
              &nbsp;({getEnglishDateWithTime(item.date)})
            </Box>
          </Box>
        </MenuItem>
      ))}
    </Select>
  );
};

export default GameSelector;
